/** @file Thai catalog part of area E5 (W3-03): the Weights panel strings, partial. */

/** The `weights` panel block (spread into `panels`); partial, English fills the gaps. */
export const weightsTh = {
  weights: {
    title: 'เมชและน้ำหนัก',
    noMesh: 'เลือก slot ที่แสดงเมช หรือจุดของเมช',
    binding: 'การผูก',
    meshLine: '{mesh} บน {slot} · {n} จุด',
    rigid: 'Rigid: ตาม bone ของ slot',
    skinned: 'Skinned: ถ่วงน้ำหนักกับ bone',
    makeSkinned: 'ทำเป็น skinned',
    makeRigid: 'ทำเป็น rigid',
    rebind: 'ผูกใหม่ที่ท่า setup',
    smooth: 'เกลี่ยน้ำหนัก',
    bones: 'Bone',
    paintWith: 'ระบายด้วย {bone}',
    vertexCount: '{n} จุด',
    noVertices: 'เลือกจุดเพื่อแก้น้ำหนัก',
    remove: 'เอาออก',
    addBone: 'bone ที่จะเพิ่ม',
    add: 'เพิ่ม',
  },
} as const;
